import { render, staticRenderFns } from "./FavoritesCard.vue?vue&type=template&id=25f542e4&scoped=true&"
import script from "./FavoritesCard.vue?vue&type=script&lang=js&"
export * from "./FavoritesCard.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesCard.vue?vue&type=style&index=0&id=25f542e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f542e4",
  null
  
)

export default component.exports